/**
  Organic Formula Custom Scripts
  By : Qadir Hassan

**/

$(document).ready(function () {
  setTimeout(function () {
    const targetButton = document.querySelector('button[aria-controls="Footer-custom_dRK8UC"]');
    const targetContent = document.getElementById('Footer-custom_dRK8UC');

    if (targetButton && targetContent) {
      targetButton.classList.add('is-open');
      targetButton.setAttribute('aria-expanded', 'true');
      targetContent.classList.add('is-open');
    } else {
      console.log('Target button or content not found.');
    }
  }, 5000);
});

const heading = document.querySelector('.why-order-heading');
heading.innerHTML = heading.innerHTML.replace(
  /(Organic.*\?)/,
  '<strong>$1</strong>'
);

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.collapsible-trigger');
  if (!trigger) return;

  const scrollable = document.querySelector('.drawer__scrollable');
  if (!scrollable) return;

  const savedScroll = scrollable.scrollTop;

  // Lock scroll
  scrollable.style.scrollBehavior = 'auto';

  requestAnimationFrame(() => {
    scrollable.scrollTop = savedScroll;

    // After animation finishes (300ms default)
    setTimeout(() => {
      scrollable.scrollTop = savedScroll;
      scrollable.style.scrollBehavior = ''; // reset to normal
    }, 350);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const pages = [
    "/collections/shop-formula",
    "/pages/shipping",
    "/blogs/news",
    "/pages/faq",
    "/pages/contact",
    "/account",
    "/pages/about-us"
  ];

  const currentURL = window.location.href;

  pages.forEach(page => {
    if (currentURL.includes(page)) {
      const link = document.querySelector(`a[href*="${page}"]`);
      if (link) {
        let parent =
          link.closest(".mobile-nav__has-sublist") || link.closest(".mobile-nav__item");
        if (parent) {
          parent.classList.add("active");
        }
      }
    }
  });
});


// This function ensures the code runs only after the DOM is fully loaded.




document.addEventListener('DOMContentLoaded', function() {

  const targetButton = document.querySelector('button[aria-controls="Footer-custom_dRK8UC"]');

  if (targetButton) {
    
    targetButton.classList.add('is-open')

    const q = document.getElementById('Footer-custom_dRK8UC').classList.add('is-open')

  

  } else {
    console.log('Target button not found with aria-controls="Footer-custom_dRK8UC".');
  }


  
$('.why-order-section.why-organic-baby-formula .why-order-cards-wrappe').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   
  ]
});


mobileOnlySlider(".why-order-section.why-organic-baby-formula .why-order-cards-wrapper-old", true, false, 769);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);

    // Initial check on page load
    if ($(window).width() < $breakpoint) {
        slider.slick({
            mobileFirst: true,
            dots: $dots,
            arrows: $arrows,
            slidesToShow: 2,
            slidesToScroll: 1
        });
    }

    // Window resize handler
    $(window).on("resize", function () {
        if ($(window).width() < $breakpoint) {
            // Re-initialize if not already a slick slider
            if (!slider.hasClass("slick-initialized")) {
                slider.slick({
                    mobileFirst: true,
                    dots: $dots,
                    arrows: $arrows,
                    slidesToShow: 2,
                    slidesToScroll: 1
                });
            }
        } else {
            // Un-slick if it's currently a slick slider
            if (slider.hasClass("slick-initialized")) {
                slider.slick("unslick");
            }
        }
    });
}


// Add Menu Drawer text
  document.querySelector('.h2.drawer__title').innerHTML = "<p>Menu</p>"


  // add class to the product tags like sold out, new etc 
  const statusElement = document.querySelectorAll('.grid-product__tag');
  for(let i=0;i<statusElement.length;i++){
    if(statusElement[i].textContent.includes('New')){
       statusElement[i].classList.add('new-arrival');
      
    }
  }

/* Home Page Product S;ider **/
mobileOnlySliderProducts(".home-featured .page-width .grid.grid--uniform", true, false, 769);
function mobileOnlySliderProducts($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: false,
    arrows: true,

    infinite:true,
    speed: 600,             
    cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', 

    slidesToShow: 2,
		slidesToScroll: 1,

    swipe: true,
		swipeToSlide: true,
		touchMove: true,
		draggable: true,

		touchThreshold: 8,
		waitForAnimate: false,
    verticalSwiping: false,
     
    edgeFriction: 0.35,
    rows:1,
    adaptiveHeight: true,
    
        
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"

			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

$('.home-featured .slick-list').on('touchstart', function(){
  $(this).css('cursor','grabbing');
});


// Change structure of single product page on Mobile
const singleMeta = document.querySelector('.product-single__meta .product-block.product-block--header');
// consloe.log('single meta',singleMeta)

 const elements = document.querySelectorAll('.home-featured .page-width .grid__item.medium-up--one-fifth');

   function removeClassOnMobile() {
    if (window.innerWidth <= 769) {
      elements.forEach(element => {
        element.classList.remove('medium-up--one-fifth');
      });
    } else {
      // Optional: Add the class back for larger screens
      elements.forEach(element => {
        element.classList.add('medium-up--one-fifth');
      });
    }
  }

  // Run the function on page load
  removeClassOnMobile();

  // Run the function on window resize
  window.addEventListener('resize', removeClassOnMobile);


/** Footer Colloaspe  */
// This script will work for screens between 768px and 1024px.
if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
  // Select all the h4 elements with the specified classes.
  const buttons = document.querySelectorAll('h4.footer__title.collapsible-trigger.collapsible-trigger-btn.medium-up--hide.is-open');

  // Loop through each button and add a click event listener.
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      // Find the next sibling element that has the class '.collapsible-content--small'.
      // This is the content you want to toggle.
      const content = this.nextElementSibling;
      
      // If the content exists, toggle the 'display-none' class on it.
      if (content && content.classList.contains('collapsible-content--small')) {
        content.classList.toggle('display-none');
      }
    });
  });
}

/* ======== Toggle SideBar Popup Functionality ============ */

// Helper function to manage cookies
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Function to open the popup
function openPopup(newsletterPopupElement) {
  if (!newsletterPopupElement) return;
  
  newsletterPopupElement.classList.add('is-active');
  document.body.classList.add('modal-open');
  document.body.classList.add('newsletter-modal-open');
  newsletterPopupElement.setAttribute('aria-expanded', 'true');
  
  // Focus on email input
  const emailInput = newsletterPopupElement.querySelector('input[type="email"]');
  if (emailInput) {
    emailInput.focus();
  }
}

// Function to close the popup
function closePopup(newsletterPopupElement) {
  if (!newsletterPopupElement) return;
  
  newsletterPopupElement.classList.remove('is-active');
  document.body.classList.remove('modal-open');
  document.body.classList.remove('newsletter-modal-open');
  newsletterPopupElement.setAttribute('aria-expanded', 'false');
}

const toggleButton = document.querySelector('.popup-toggle-btn');
const newsletterPopupElement = document.querySelector('.shopify-section-group-popup-group > div');

// Check if user has seen the popup before
const hasSeenPopup = getCookie('newsletter_popup_seen');

// Auto-open popup for new users after delay
if (!hasSeenPopup && newsletterPopupElement) {
  // Change delay time here (in milliseconds): 5000 = 5 seconds, 10000 = 10 seconds
  const delayTime = 5000; // 5 seconds
  
  setTimeout(() => {
    openPopup(newsletterPopupElement);
   document.body.classList.add('newsletter-modal-open');
    // Set cookie to remember user has seen the popup (expires in 30 days)
    setCookie('newsletter_popup_seen', 'true', 30);
  }, delayTime);
}

if (toggleButton) {
  toggleButton.addEventListener('click', function(event) {
    event.preventDefault();

    if (!newsletterPopupElement) {
      console.warn('Newsletter popup element not found. Make sure the section is rendered on the page and its ID is correct.');
      return;
    }

    // Toggle the popup
    const isActive = newsletterPopupElement.classList.contains('is-active');
    if (isActive) {
      closePopup(newsletterPopupElement);
    } else {
      openPopup(newsletterPopupElement);
    }
  });
} else {
  console.warn('Newsletter popup toggle button (.popup-toggle-btn) not found.');
}

// Handle close button
if (newsletterPopupElement) {
  const closeButton = newsletterPopupElement.querySelector('.js-modal-close');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      closePopup(newsletterPopupElement);
    });
  }

  // Close when clicking on overlay
  newsletterPopupElement.addEventListener('click', function(event) {
    if (event.target === newsletterPopupElement) {
      closePopup(newsletterPopupElement);
    }
  });

  
  const newsbtn = newsletterPopupElement.querySelector('.btn.newsletter-button .button--text');
   if (newsbtn) {
    newsbtn.addEventListener('click', function() {
      closePopup(newsletterPopupElement);
    });
  }
}



  // FAQ Toogle transitiuon
// FAQ Toggle transition

document.querySelectorAll('.custom-faq .collapsible-trigger').forEach(btn => {
  btn.addEventListener('click', () => {
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isOpen));
  });
});




const parentContainer = document.querySelector('.site-footer .page-width .grid > div:nth-child(7) button');
parentContainer.classList.remove('collapsible-trigger')
parentContainer.classList.remove('collapsible-content')
parentContainer.classList.remove('collapsible-content--small')
parentContainer.classList.remove('is-open')


  // Main function ends here
});



/* Jquery Code */
$(document).ready(function () {
  $('.variant-input-wrap').each(function () {
    if ($(this).find('.variant-input').length === 4) {
      $(this).addClass('fourBox');
    }
  });

/* ========== Change the H2 Structure on Contact Page on Mobile ============ */
const mediaQuery = window.matchMedia('(max-width: 1024px)');
const headline = $('.page-contact-section-first .content-row h2');
const contentRow = $('.page-contact-section-first .content-row ');
const imageRow = $('.page-contact-section-first .image-row ');

function handleHeadlinePlacement(e) {
  if (e.matches) {
    // If screen is <= 1024px, move headline to image-row
    headline.prependTo(imageRow);
  } else {
    // If screen is > 1024px, move headline back to content-row
    headline.prependTo(contentRow);
  }
}

// 1. Run on initial load
handleHeadlinePlacement(mediaQuery);

// 2. Listen for changes
mediaQuery.addListener(handleHeadlinePlacement);


$('body').removeClass('klaviyo-prevent-body-scrolling')
$('.we-are-recommended-logo-box .text-column__grid a').attr('target','_blank');


// 1. Target the element to be clicked (the review count)

/* add shop formula link to hero btn */
$('.hero__text-wrap .hero__link a').attr('href','https://organicformulashop.com/collections/shop-formula')



 $('body.template-product #SiteHeader .mobile-logo').wrap("<a href='https://organicformulashop.com/'></a>");

 /* hide popup button when drawer menu opens*/
const drawer = document.getElementById('NavDrawer');
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      if($('#NavDrawer').hasClass('drawer--is-open')){
        $('.popup-toggle-btn').hide();
      } else {
        $('.popup-toggle-btn').show();
      }
    }
  });
});

observer.observe(drawer, { attributes: true });

 /* hide popup button when Mini Cart opens*/
const minidrawer = document.getElementById('CartDrawer');
const miniobserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      if($('#CartDrawer').hasClass('drawer--is-open')){
        $('.popup-toggle-btn').hide();
      } else {
        $('.popup-toggle-btn').show();
      }
    }
  });
});

miniobserver.observe(minidrawer, { attributes: true });

/** Add a class when there is A Gift Card Image in Cart */

$('.template-cart .cart__page img[srcset*="giftcard.jpg"]').addClass('gift-card-img');
/* Add a class to body on SIngle product if is a giftcard */
// 1. Check for element existence using the corrected selector.
const selector = 'img.image-element[srcset*="giftcard.jpg"]';
    if ($(selector).length > 0) {
        // 2. Add the class to the body if the element is found.
$('body').addClass("gift-card-product"); } 

$('#CartDrawer .cart__image img[srcset*="giftcard.jpg"]').addClass('gift-card-img')


/* Add a unique class if there is only one item in mini cart*/
const cartItems = $('#CartDrawer .drawer__inner .drawer__scrollable .cart__item');

if (cartItems.length === 1) {$('#CartDrawer .drawer__inner .drawer__scrollable').addClass('mini-cart-single-item');} 

/** Remove fade animation on collection product images */
var $productImages = $('#CollectionAjaxContent .grid-product .image-wrap  image-element');

    // 🔨 Remove the unwanted attributes
    $productImages.removeAttr('data-aos');
    $productImages.removeAttr('data-aos-offset');

/* Add Target attribute in footer menu */
$('.site-footer a[href="https://organic-formula-shop.goaffpro.com/"]').attr('target', '_blank');

/* on Home page add okendo image in parent review page*/
setTimeout(function() {
 
    const newHtml = '<div class="okendo-img">' +
                  '  <img src="https://cdn.shopify.com/s/files/1/0576/2547/7320/files/okedno-star.svg" alt="okendo star" />' +
                  '</div>';
    $('.template-index .oke-ratingsBadge .oke-minimalBadge').append(newHtml);
    
}, 5000); // Adjust the delay (1000ms = 1s) as needed



/* Jquery ends here*/
});



jQuery(document).ready(function ($) {
  function scrollToReviews() {
    var $reviewsAccordion = $("#reviews");
    // Check if reviews accordion is not already active
    if ($reviewsAccordion.hasClass("accordion-active") == false) {
      // Scroll to accordion section first
      $("html, body").animate(
        { scrollTop: $reviewsAccordion.offset().top - 100 },
        "slow"
      );
      // Trigger click on the reviews accordion title to open it
      $reviewsAccordion.find(".accordion__title").trigger("click");
    } else {
      // If already open, just scroll to it
      $("html, body").animate(
        { scrollTop: $reviewsAccordion.offset().top - 100 },
        "slow"
      );
    }
  }
  setTimeout(() => {
    $(".oke-sr-count").on("click", function () {
      console.log("clicked");
      scrollToReviews();
    });
  }, 700);

  $('.variant-input-wrap').each(function () {
    if ($(this).children('div').length > 3) {
      $(this).addClass('moreDiv');
    }
  });
});


// Auto-close filter sections when checkbox is selected
document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation on the document to handle dynamically updated checkboxes
  document.addEventListener('change', function(e) {
    // Check if the changed element is a filter checkbox
    if (e.target.classList.contains('tag__input')) {
      // Find the closest collapsible-content container
      const collapsibleContent = e.target.closest('.collapsible-content');
      
      if (collapsibleContent && collapsibleContent.classList.contains('is-open')) {
        // Get the collapsible ID
        const collapsibleId = collapsibleContent.getAttribute('data-collapsible-id');
        
        // Find the trigger button using data-collapsible-id
        const triggerButton = document.querySelector(`[data-collapsible-id="${collapsibleId}"].collapsible-trigger`);
        
        if (triggerButton) {
          // Remove is-open class from button
          triggerButton.classList.remove('is-open');
          triggerButton.setAttribute('aria-expanded', 'false');
          
          // Remove is-open class from content and collapse it
          collapsibleContent.classList.remove('is-open');
          collapsibleContent.style.height = '0px';
        }
      }
    }
  }, true); // Use capture phase to ensure it catches the event
});


